import {
  ManagedBy,
  PrimaryAction,
  SampleType,
  TestCard,
} from "@app/provider/testData/types";
import { IntlShape } from "react-intl";
import { messages } from "@app/provider/testData/messages";
import { Utils } from "@natera/material/lib/date";
import { getEstimatedResultsDeliveryDate } from "@app/utils";
import { ConnectTestCardBase } from "@app/provider/testData/testCard/connect/ConnectTestCardBase";

export class EmpowerTestCard extends ConnectTestCardBase {
  protected getDescriptionForTestOrdered(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (
      testCard.sampleType === SampleType.SALIVA &&
      testCard.managedBy === ManagedBy.NATERA
    ) {
      return intl.formatMessage(messages.testCardDescSubmitKit);
    } else if (
      testCard.sampleType === SampleType.BLOOD &&
      testCard.managedBy === ManagedBy.NATERA
    ) {
      return intl.formatMessage(messages.testCardBloodDrawTestOrdered);
    } else if (testCard.managedBy === ManagedBy.CLINIC) {
      return intl.formatMessage(
        messages.testCardDescOrderedConnectManagedByClinic
      );
    }
  }

  protected getDescriptionForSampleReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (!testCard.sampleReceivedDate) {
      return intl.formatMessage(
        messages.testCardDefaultDescSampleReceivedEmpower
      );
    }
    return super.getDescriptionForSampleReceived(testCard, intl);
  }

  protected getDescriptionForResultReady(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (
      testCard.isEmpowerStatPanelIncluded &&
      testCard.sampleReceivedDate &&
      testCard.isLatestReleasedResultStat
    ) {
      const estimatedResultsDeliveryDate = Utils.getUSLocaleDate(
        getEstimatedResultsDeliveryDate(
          testCard,
          new Date(testCard.sampleReceivedDate)
        )
      );

      return intl.formatMessage(
        messages.testCardDescResultReadyReviewEmpowerStat,
        { estimatedResultsDate: estimatedResultsDeliveryDate }
      );
    }
    return super.getDescriptionForResultReady(testCard, intl);
  }

  protected getPrimaryActionForTestOrdered(
    testCard: TestCard
  ): PrimaryAction | undefined {
    if (testCard.sampleType === SampleType.BLOOD) {
      if (testCard.managedBy === ManagedBy.NATERA) {
        return PrimaryAction.SCHEDULE_A_DRAW;
      } else if (testCard.managedBy === ManagedBy.CLINIC) {
        return PrimaryAction.VIEW_TEST_DETAILS;
      }
    } else if (
      testCard.sampleType === SampleType.SALIVA &&
      testCard.managedBy === ManagedBy.CLINIC
    ) {
      return PrimaryAction.VIEW_TEST_DETAILS;
    } else if (testCard.managedBy === ManagedBy.CLINIC) {
      return PrimaryAction.VIEW_TEST_DETAILS;
    }
    return undefined;
  }

  protected getPrimaryActionForKitShipped(
    testCard: TestCard
  ): PrimaryAction | undefined {
    return testCard.sampleType === SampleType.BLOOD
      ? PrimaryAction.SCHEDULE_A_DRAW
      : undefined;
  }
}
